import type { ClientContext } from '~/services/contextClient';
import CorporateLifecycleStatusDefinitionsClient from './corporateLifecycleStatusDefinitionsClient';
import type { LifecycleStatusDefinitionsClientInterface } from './lifecycleStatusDefinitionsClient.types';

export default class LifecycleStatusDefinitionsClientFactory {
    static createClient(context: ClientContext): LifecycleStatusDefinitionsClientInterface {
        if (!context.orgUnitId && !context.groupId) {
            return new CorporateLifecycleStatusDefinitionsClient(context.teamId);
        }

        throw new Error('Lifecycle status definitions are only available at corporate level');
    }
}
